import { Room } from './room';

export const CLUSTERS = {
    VA: {
        LIGHT: 'light-side',
        DARK: 'dark-side'
    },
    IL: 'il'
};

export class Cluster {
    id: number;
    name: string;
    rooms: Room[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/cluster.ts